import React from 'react'
import {Link} from 'react-router-dom';

const Header = () => {
    return (
        
            <header id="header" className="header fixed-top d-flex align-items-center ">

                <div className="d-flex align-items-center justify-content-between">
                    <Link to='/admin' className='logo d-flex align-items-center'>
                        <span className="d-none d-lg-block">Sales Dashboard</span>
                    <i className="bi bi-list toggle-sidebar-btn"></i>
                    </Link>
                    
                </div>


            </header>

        
    )
}

export default Header;